var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRadio01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.98px",
    height: "16.027px",
    viewBox: "79.344 139.652 15.98 16.027",
    enableBackground: "new 79.344 139.652 15.98 16.027",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M83.003,139.652c-2.019,0-3.659,1.604-3.659,3.574c0,1.972,1.641,3.576,3.659,3.576 c2.017,0,3.658-1.604,3.658-3.576C86.662,141.256,85.02,139.652,83.003,139.652z M83.003,145.816c-1.461,0-2.65-1.162-2.65-2.59 c0-1.427,1.189-2.588,2.65-2.588s2.648,1.161,2.648,2.588C85.652,144.654,84.464,145.816,83.003,145.816z M83.003,141.295 c-1.091,0-1.978,0.867-1.978,1.932c0,1.066,0.887,1.933,1.978,1.933c1.09,0,1.977-0.866,1.977-1.933 C84.98,142.162,84.093,141.295,83.003,141.295z M83.003,144.173c-0.534,0-0.969-0.425-0.969-0.946 c0-0.521,0.435-0.945,0.969-0.945c0.533,0,0.967,0.425,0.967,0.945C83.97,143.748,83.537,144.173,83.003,144.173z M88.259,142.611 v0.986h7.065v-0.986H88.259z M83.003,148.529c-2.019,0-3.659,1.604-3.659,3.575s1.641,3.575,3.659,3.575 c2.017,0,3.658-1.604,3.658-3.575S85.02,148.529,83.003,148.529z M83.003,154.693c-1.461,0-2.65-1.161-2.65-2.589 s1.189-2.589,2.65-2.589s2.648,1.161,2.648,2.589S84.464,154.693,83.003,154.693z M88.259,152.474h7.065v-0.986h-7.065V152.474z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadio01);
export default __webpack_public_path__ + "static/media/icon_radio-01.d953244c366a4578173a36245aea5168.svg";
export { ForwardRef as ReactComponent };